// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ModelTrackerOutput
 */
export interface ModelTrackerOutput {
  /**
   *
   */
  result: number;
}

/**
 * Check if a given object implements the ModelTrackerOutput interface.
 */
export function instanceOfModelTrackerOutput(value: object): value is ModelTrackerOutput {
  if (!("result" in value) || value["result"] === undefined) return false;
  return true;
}

export function ModelTrackerOutputFromJSON(json: any): ModelTrackerOutput {
  return ModelTrackerOutputFromJSONTyped(json, false);
}

export function ModelTrackerOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ModelTrackerOutput {
  if (json == null) {
    return json;
  }
  return {
    result: json["result"],
  };
}

export function ModelTrackerOutputToJSON(json: any): ModelTrackerOutput {
  return ModelTrackerOutputToJSONTyped(json, false);
}

export function ModelTrackerOutputToJSONTyped(
  value?: ModelTrackerOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    result: value["result"],
  };
}
